namespace TabAurous.ProductDevelopment {
    export namespace POSRequirementItemsService {
        export const baseUrl = 'ProductDevelopment/POSRequirementItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<RequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ProductDevelopment/POSRequirementItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSRequirementItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
